import { render, staticRenderFns } from "./UserEmail.vue?vue&type=template&id=65629952&scoped=true&"
import script from "./UserEmail.vue?vue&type=script&lang=js&"
export * from "./UserEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65629952",
  null
  
)

export default component.exports